import news1 from "../media/guestpage/news_1.png";
import news2 from "../media/guestpage/news_2.png";
import about1 from "../media/guestpage/about_1.png";
import about2 from "../media/guestpage/about_2.png";
import about3 from "../media/guestpage/about_3.png";
import about4 from "../media/guestpage/about_4.png";

export const GUEST_SECTION_IDS = {
    home: "home",
    teaser: "teaser",
    news: "news",
    features: "features",
    support: "support",
};

export const GUEST_SOCIAL_LINKS = [
    {
        id: "discord",
        href: "https://discord.gg/Z9H24ctH",
        label: "Discord",
    },
    {
        id: "telegram",
        href: "https://t.me/medieval_rp",
        label: "Telegram",
    },
    {
        id: "youtube",
        href: "https://www.youtube.com/@medievalrpnet",
        label: "YouTube",
    },
    {
        id: "twitch",
        href: "https://www.twitch.tv/medievalrpnet",
        label: "Twitch",
    },
    {
        id: "vk",
        href: "https://vk.com/medievalrpnet",
        label: "VK",
    },
    {
        id: "tiktok",
        href: "https://www.tiktok.com/@medieval.rp.net",
        label: "TikTok",
    },
];

export const GUEST_STATS = {
    users: 1100,
    characters: 1100,
};

export const GUEST_NEWS = [
    {
        id: 1,
        image: news1,
        dayNumber: "6",
        month: "ИЮНЯ",
        year: "2026",
        day: "СБ",
        time: "19:00",
        title: "ПРЯМАЯ ТРАНСЛЯЦИЯ СОЗДАНИЯ ПРОЕКТА MEDIEVAL ROLEPLAY",
        href: "#",
    },
    {
        id: 2,
        image: news2,
        dayNumber: "12",
        month: "ИЮНЯ",
        year: "2026",
        day: "ПТ",
        time: "18:00",
        title: "ОБНОВЛЕНИЕ РОЛЕВЫХ МЕХАНИК И НОВЫЕ ФРАКЦИИ",
        href: "#",
    },
    {
        id: 3,
        image: news1,
        dayNumber: "20",
        month: "ИЮНЯ",
        year: "2026",
        day: "СБ",
        time: "20:00",
        title: "ОТКРЫТИЕ СЕЗОНА И СПЕЦИАЛЬНЫЕ ИВЕНТЫ ДЛЯ ИГРОКОВ",
        href: "#",
    },
    {
        id: 4,
        image: news2,
        dayNumber: "28",
        month: "ИЮНЯ",
        year: "2026",
        day: "ВС",
        time: "17:30",
        title: "ИТОГИ КОНКУРСА СКРИНШОТОВ И НАГРАДЫ УЧАСТНИКАМ",
        href: "#",
    },
];

export const GUEST_FEATURES = [
    {
        id: "01",
        text: "УНИКАЛЬНЫЙ РОЛЕВОЙ ПРОЕКТ В СЕТТИНГЕ СРЕДНЕВЕКОВОГО ФЭНТЕЗИ",
        image: about1,
    },
    {
        id: "02",
        text: "ИММЕРСИВНАЯ ЭКОНОМИКА И МНОЖЕСТВО ВИДОВ ПРЕДПРИЯТИЙ",
        image: about2,
    },
    {
        id: "03",
        text: "УНИКАЛЬНЫЕ ФРАКЦИИ И ОСОБЫЕ РОЛИ",
        image: about3,
    },
    {
        id: "04",
        text: "ПОЛНАЯ СВОБОДА ДЕЙСТВИЙ ВАШЕГО ПЕРСОНАЖА",
        image: about4,
    },
];

export const SUPPORT_TOPICS = [
    "Техническая проблема",
    "Вопрос по аккаунту",
    "Жалоба на игрока",
    "Предложение по проекту",
    "Другое",
];

export const FOOTER_NAV_LINKS = [
    { label: "Главная", href: `#${GUEST_SECTION_IDS.home}` },
    { label: "Новости", href: `#${GUEST_SECTION_IDS.news}` },
    { label: "О сервере", href: `#${GUEST_SECTION_IDS.teaser}` },
    {
        label: "Техническая поддержка",
        href: `#${GUEST_SECTION_IDS.support}`,
    },
];

export const FOOTER_LEGAL_LINKS = [
    { label: "Политика конфиденциальности", href: "/privacy_policy.pdf" },
    {
        label: "Пользовательское соглашение",
        href: "/medieval_rp_net_offer_user_agreement_FINAL_v2.pdf",
    },
];
